import PaidSuccess from './paid-success';

export default PaidSuccess;
